var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tri-manager',{attrs:{"table-fetch":_vm.tableFetch,"table-fetch-active":_vm.tableFetchActive,"table-archive":_vm.tableArchive,"table-restore":_vm.tableRestore,"table-columns":_vm.tableColumns}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d3bc5fd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Organization/organizationData/organizationSettingsRates.vue
// module id = null
// module chunks = 